module.exports = new __parcel__URL__("battlepass_assign_all_button.842d036d.png").toString();